<template>
  <div id="dtBasicExample_wrapper" class="dataTables_wrapper dt-bootstrap4">
    <br>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div id="dtBasicExample_filter" class="dataTables_filter">
          <label>
            Buscar Nombre:
            <input
              type="search"
              class="form-control form-control-sm"
              placeholder
              aria-controls="dtBasicExample"
              v-model="taskSearch"
            />
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <table
          id="dtBasicExample"
          class="table table-striped table-bordered table-sm dataTable table-responsive"         
        >
          <thead class="thead-dark">
            <tr role="row">
              <th>Id</th>
              <th>Nombre</th>
              <th>Es menu</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <taskComponent v-for="(tsk, key) in filteredTaskList" :task="tsk" :key="key" />
          </tbody>
        </table>
      </div>
    </div>    
  </div>
</template>

<script>
import taskComponent from "./Task.vue";
import { getAllCategories } from "./../../api/conection";

export default {
  name: "taskListComponent",
  props: {
    taskList: {
      type: Array,
      default: []
    }
  },
  components: {
    taskComponent
  },
  mounted() {
    
    getAllCategories()
      .then(response => {
        if (response.status === 200)
          this.$store.dispatch("setCategoriesAction", response.body);
      })
      .catch(err => {
        console.log(err);
      });
      
  },
  computed: {
    filteredTaskList() {
      return this.taskList.filter(tsk => {
        return tsk.name.toLowerCase().includes(this.taskSearch.toLowerCase());
      });
    }
  },
  data() {
    return {
      taskSearch: "",      
    };
  }
};
</script>
<style>
table.dataTable thead .sorting:after,
table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_desc_disabled:after,
table.dataTable thead .sorting_desc_disabled:before {
  bottom: 0.5em;
}
</style>